export const SOURCES_I18N_PREFIX = "features.sources.sources";

export const SOURCES_I18N_KEYS = {
  facebook_dropdown_header_label:   "facebook_dropdown_header_label",
  facebook_disconnect_button_label: "facebook_disconnect_button_label",
  forums_dropdown_header_label:     "forums_dropdown_header_label"
}


// WEBPACK FOOTER //
// ./src/features/sources/constants/i18n/Sourcesi18nConstants.js